import { useState } from "react";

export interface IConfirmForm {
	note?: string;
	poNumber?: string;
	shipTo?: string;
	reasonWhy?: string;
	orderReasons?: string;
	sendToSap: boolean
}

const defaultValues = {
	note: "",
	poNumber: "",
	shipTo: "",
	reasonWhy: "",
	orderReasons: "",
	sendToSap: true
};

export const useConfirmForm = () => {
	const [formValues, setFormValues] = useState<IConfirmForm>(defaultValues);

	const handleInitialize = (values: IConfirmForm) => setFormValues(values);

	const handleChange = (name: string, value: any) => {
		setFormValues({
			...formValues,
			[name]: value
		});
	};

	const handleChangeMultiple = (multipleValues: any) => {
		setFormValues({
			...formValues,
			...multipleValues
		});
	};

	return {
		handleInitialize,
		handleChange,
		handleChangeMultiple,
		formValues
	};
};

export class ConfirmFormValidator {
	static validateForm = (values: IConfirmForm) => {
		let formErrors: any = {};

		if (!values.poNumber) {
			formErrors.poNumber = "Field required.";
		}

		if (!values.shipTo) {
			formErrors.shipTo = "Field required.";
		}

		if (!values.orderReasons) {
			formErrors.orderReasons = "Field required.";
		}

		return formErrors;
	};
}

export class CancelFormValidator {
	static validateForm = (values: IConfirmForm) => {
		let formErrors: any = {};

		if (!values.reasonWhy) {
			formErrors.reasonWhy = "Field required.";
		}

		if (!values.note) {
			formErrors.note = "Field required.";
		}

		return formErrors;
	};
}